import { axios } from './axios.js';
import { HEADERS } from './constants.js';

export const checkOrganization = async data => {
  const response = await axios.post('/organization/check', data);
  return response.data;
};

export const checkUser = async data => {
  const response = await axios.post('/organization/checkuser', data);
  return response.data;
};

export const checkOrganizationByPartial = async searchData => {
  const response = await axios.post('/organization/check/partial', searchData);
  return response.data;
};

export const createOrganization = async formData => {
  const response = await axios.post('/organization/create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const joinRequest = async data => {
  const response = await axios.post('/organization/join/request', data);
  return response.data;
};

export const withdrawRequest = async () => {
  const response = await axios.delete('/organization/withdraw/request');
  return response.data;
};

export const approveJoinRequest = async data => {
  const response = await axios.post('/organization/join/request/approve', data);
  return response.data;
};

export const editOrgDetails = async (organizationId, data) => {
  const response = await axios.put(
    `/organization/details/${organizationId}`,
    data,
  );
  return response.data;
};

export const deleteOrganization = async organizationId => {
  const response = await axios.delete(`/organization/${organizationId}/delete`);
  return response.data;
};

export const getOrganizationList = async () => {
  const response = await axios.get('/organization/get/list');
  return response.data;
};

export const getAllOrganizations = async () => {
  const response = await axios.get('/organization/get/all');
  return response.data;
};

export const getUsersByOrg = async (organizationId, params = {}) => {
  const response = await axios.get(
    `/organization/get/user/${organizationId}/list`,
    { params },
  );
  return response.data;
};

export const getOrgDetails = async organizationId => {
  const response = await axios.get(
    `/organization/details/${organizationId}/get`,
  );
  return response.data;
};

export const getOrgUserDetails = async organizationId => {
  const response = await axios.get(
    `/organization/details/${organizationId}/users/get`,
  );
  return response.data;
};

export const checkUserInOrganization = async (organizationId, uid) => {
  const response = await axios.get(
    `/organization/${organizationId}/users/${uid}/check`,
  );
  return response.data;
};

export const getOrganizationById = async organizationId => {
  const response = await axios.get(`/organization/${organizationId}`);
  return response.data;
};

export const getOrganizationBilling = async organizationId => {
  const response = await axios.get(`/organization/${organizationId}/billing`);
  return response.data;
};

export const updateOrgDetails = async (organizationId, formData) => {
  const response = await axios.patch(
    `/organization/${organizationId}/update`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const getOrgLogo = async organizationId => {
  const response = await axios.get(`/organization/${organizationId}/logo`);
  return response.data;
};

export const removeUserFromOrganization = async (organizationId, userId) => {
  const response = await axios.delete(
    `/organization/${organizationId}/users/${userId}/delete`,
  );
  return response.data;
};

export const fetchOrgDashboardData = async organizationId => {
  const response = await axios.get(`/organization/dashboard/${organizationId}`);
  return response.data;
};

export const getOrganizationRepositories = async organizationId => {
  const response = await axios.get(
    `/organization/${organizationId}/repositories`,
  );
  return response.data;
};

export const organizationUsersList = async (
  organizationId,
  limit = 25,
  page = 1,
  requestAccepted,
) => {
  const params = new URLSearchParams();
  params.append('limit', limit.toString());
  params.append('page', page.toString());
  if (requestAccepted !== undefined) {
    params.append('requestAccepted', requestAccepted);
  }

  const response = await axios.get(
    `/organization/get/user/${organizationId}/list?${params.toString()}`,
  );
  return response.data;
};

export const updateUser = async (organizationId, organizationUserId, data) => {
  axios.defaults.headers.common[HEADERS.ORGANIZATION_ID] = organizationId;
  const response = await axios.put(
    `/user-management/${organizationUserId}/update`,
    data,
  );
  return response.data;
};

export const approveRequest = async (userId, organizationId) => {
  const response = await axios.post('/organization/join/request/approve', {
    userId,
    organizationId,
  });
  return response.data;
};

export const resendInvitation = async (organizationId, userId) => {
  const response = await axios.post(
    `/organization/${organizationId}/users/${userId}/resend-invitation`,
  );
  return response.data;
};

export const registrationByAdmin = async data => {
  const response = await axios.post('/auth/user-invitation', data);
  return response.data;
};

export const getInvoices = async organizationId => {
  const response = await axios.get(`/subscription/invoices/${organizationId}`);
  return response.data;
};

// Groups management
export const updateOrganizationGroups = async (organizationId, groups) => {
  const response = await axios.put(`/organization/${organizationId}/groups`, {
    groups,
  });
  return response.data;
};

export const updateOrganizationUserGroups = async (
  organizationId,
  userId,
  groups,
) => {
  const response = await axios.put(
    `/organization/${organizationId}/users/${userId}/groups`,
    { groups },
  );
  return response.data;
};
